var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","flat":""}},[_c('v-app-bar-title',{staticClass:"text-no-wrap"},[_c('span',{staticClass:"text-no-wrap"},[_vm._v(_vm._s(_vm.title))])]),_c('v-spacer'),_c('Divisa')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }